<adapt-dialog [maxWidth]="540"
              [fitHeight]="true">
    <h3 adapt-dialog-title>New meeting template</h3>
    <div adapt-dialog-content
         class="h-100 d-flex flex-column">
        <div class="alert alert-info">
            <p>You can choose to save this meeting template in a team or for the organisation.</p>
        </div>

        <h4>Template name</h4>
        <dx-text-box [(value)]="templateName"
                     placeholder="Enter a template name"></dx-text-box>

        <h4 class="mt-4">Template location</h4>
        <adapt-select-teams [filter]="filter"
                            [singleSelection]="true"
                            [selectedTeamIds]="[templateLocationTeamId]"
                            (teamsSelectedChange)="onTeamsSelectionChanged($event)"></adapt-select-teams>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveBlockingClick]="saveAsMeetingTemplate"
                                   saveText="Save template"
                                   (cancelClick)="cancel()"
                                   [saveIsDisabled]="!templateName || (!this.templateLocationTeamId && this.templateLocationTeamId !== null)"></adapt-standard-dialog-buttons>
</adapt-dialog>
